// added for unit test purpose only
module.exports = {
    registration: {
        receiveSmsOfferByDefault: null,
        receiveEmailsByDefault: null,
        receiveSampleByDefault: null,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/registration.js